import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import DataUtils from 'data/utils';

export default CreateReactClass({
    displayName: 'batch-print-navigation',

    PropTypes: {
        batchTab: PropTypes.oneOf(['class', 'subjects', 'pages', 'students', 'status']).isRequired,
        isFamilyReport: PropTypes.bool.isRequired,
        nextButtonAction: PropTypes.func.isRequired,
        pagesChanged: PropTypes.bool.isRequired,
        selectedModule: PropTypes.instanceOf(Immutable.Map).isRequired, //passed as props to subjectTabClasses and studentTabClasses in DataUtils
        selectedPages: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectedStudentForPrinting: PropTypes.oneOf(['previous', 'current', 'next']).isRequired,
        selectedStudentsFromList: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectedSubjects: PropTypes.instanceOf(Immutable.Set).isRequired,
        studentsChanged: PropTypes.bool.isRequired,
        subjectsChanged: PropTypes.bool.isRequired,
        students: PropTypes.instanceOf(Immutable.List).isRequired, //passed as props to subjectTabClasses and pageTabClasses in DataUtils
        visitedSections: PropTypes.instanceOf(Immutable.Set).isRequired,
    },

    getPagesTab() {
        if (this.props.isFamilyReport) {
            return;
        }
        const pageClasses = DataUtils.tabClasses('pages', this.props);
        return (
            <li
                className={pageClasses}
                onClick={
                    this.props.visitedSections.includes('pages')
                        ? (event) => this.props.nextButtonAction(event, 'pages')
                        : () => {}
                }
            >
                <span className="tab-label">pages</span>
            </li>
        );
    },

    selectionTabClick(event) {
        this.props.toggleStudentSelection(event, 'all');
        this.props.nextButtonAction(event, 'class');
        this.props.clearSelectedStudents();
    },

    getClassTab() {
        if (!this.props.isFamilyReport || !this.props.isFamilyReportURL) {
            return;
        }
        const classSelectionClasses = DataUtils.tabClasses('class', this.props);
        return (
            <li className={classSelectionClasses} onClick={this.selectionTabClick}>
                <span className="tab-label">class</span>
            </li>
        );
    },

    render() {
        const { visitedSections } = this.props;
        const studentClasses = DataUtils.tabClasses('students', this.props);
        const subjectClasses = DataUtils.tabClasses('subjects', this.props);
        const dataClasses = DataUtils.tabClasses('data', this.props);

        return (
            <div className="print-batch-navigation">
                <ul key="work-flow-tabs" className="work-flow-tabs">
                    {this.getClassTab()}
                    <li
                        className={subjectClasses}
                        onClick={
                            visitedSections.includes('subjects')
                                ? (event) => this.props.nextButtonAction(event, 'subjects')
                                : () => {}
                        }
                    >
                        <span className="tab-label">subjects</span>
                    </li>
                    <li
                        className={dataClasses}
                        onClick={
                            visitedSections.includes('data')
                                ? (event) => this.props.nextButtonAction(event, 'data')
                                : () => {}
                        }
                    >
                        <span className="tab-label">data</span>
                    </li>
                    {this.getPagesTab()}
                    <li
                        className={studentClasses}
                        onClick={
                            visitedSections.includes('students')
                                ? (event) => this.props.nextButtonAction(event, 'students')
                                : () => {}
                        }
                    >
                        <span className="tab-label">students</span>
                    </li>
                    <li className="current-tab-indicator" />
                </ul>
            </div>
        );
    },
});
